var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 102.088,
    height: 80.033,
    viewBox: "0 0 102.088 80.033",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-growth-6429795",
    transform: "translate(-12.336 -3.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6442",
    "data-name": "Path 6442",
    d: "M114.293,4.172a1.854,1.854,0,0,1-1.045,2.41C79.931,19.759,38.52,47.032,19.9,78.692l8.288-1.365a1.856,1.856,0,0,1,.6,3.663l-12.3,2.02a1.849,1.849,0,0,1-2.131-1.532l-1.992-12.1a1.856,1.856,0,0,1,3.663-.6l1.184,7.187c8.413-13.929,21.868-28.15,39.113-41.3A239.676,239.676,0,0,1,111.884,3.128,1.968,1.968,0,0,1,112.566,3,1.825,1.825,0,0,1,114.293,4.172Z",
    transform: "translate(0 0)",
    fill: "#f7edd6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLower);
export default __webpack_public_path__ + "static/media/arrow-lower.bbe390b7a83972518cecdd9b2242d866.svg";
export { ForwardRef as ReactComponent };